import { render, staticRenderFns } from "./TheSidebarWeather.vue?vue&type=template&id=2f63e42e&scoped=true&"
import script from "./TheSidebarWeather.vue?vue&type=script&lang=js&"
export * from "./TheSidebarWeather.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebarWeather.vue?vue&type=style&index=0&id=2f63e42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63e42e",
  null
  
)

export default component.exports